import Box from "@mui/material/Box";

const WorkspaceThumbnail = ({
  iconStyling,
  size = 48,
  src,
}) => {
  var { borderColor, borderRadius, borderWidth, boxShadow } = iconStyling || {};

  return (
    <Box
      component="img"
      alt=""
      src={src}
      sx={{
        aspectRatio: 1,
        border: "0 none",
        borderColor,
        borderRadius,
        borderStyle: "solid",
        borderWidth,
        boxSizing: "border-box",
        boxShadow,
        width: size,
      }}
    />
  );
};

export default WorkspaceThumbnail;
